/**
 * Lightweight test/debug logger that provides a subset of the legacy
 * `@suntex.classic/utils` `TestUtil` API for ported module bodies.
 * Not a full drop-in replacement — `SHOW_WARNINGS` is exposed via
 * `setShowWarnings()` and `log()` always emits a `console.log`.
 * Prefer `@suntex.core/logging` for new code.
 *
 * @deprecated Use `@suntex.core/logging` `Logger` for new code.
 */

let _showWarnings = true;

export function setShowWarnings(value: boolean): void {
  _showWarnings = value;
}

export function log(...args: unknown[]): void {
  // eslint-disable-next-line no-console
  console.log(args.join(', '));
}

export function logObject(o: unknown): void {
  // eslint-disable-next-line no-console
  console.log(o);
}

export function warn(message: unknown, ctx = ''): void {
  if (!_showWarnings) return;
  // eslint-disable-next-line no-console
  console.warn(ctx, message);
}
